import type { EntryMeta } from '~/types'
import Canvas from '~/components/Canvas'
import type { MediaPath } from '~/generated/media'

const cover = 'projects/pattern.jpg' satisfies MediaPath

export const meta: EntryMeta = {
	slug: 'field',
	name: 'Field',
	excerpt: 'Animated sine interference on canvas',
	tags: ['canvas', 'generative'],
	cover,
	order: 10,
}

export default function Field() {
	return (
		<div className="relative w-full h-[70vh] bg-black">
			<Canvas
				resizeToParent
				className="block w-full h-full"
				loop={(ctx, t) => {
					const { width, height } = ctx.canvas
					ctx.fillStyle = 'rgba(0,0,0,0.08)'
					ctx.fillRect(0, 0, width, height)
					ctx.strokeStyle = '#84db00'
					ctx.lineWidth = 1
					for (let i = 0; i < 24; i += 1) {
						ctx.beginPath()
						const phase = t / 1000 + i * 0.3
						for (let x = 0; x <= width; x += 6) {
							const y =
								height / 2 + Math.sin(x * 0.01 + phase) * (height / 4) * Math.cos(phase + x * 0.002)
							if (x === 0) ctx.moveTo(x, y)
							else ctx.lineTo(x, y)
						}
						ctx.globalAlpha = 0.15
						ctx.stroke()
					}
					ctx.globalAlpha = 1
				}}
			/>
		</div>
	)
}
